module.exports = __webpack_public_path__ + "static/patryk-karczmarczyk-x2-0ef6a00891f3e7942ebb281da5a41c71.jpg";